
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"currentColor","stroke":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"m3.132 12.8.448-1.175-1.046-2.744a.929.929 0 0 1 .36-1.107l2.458-1.605.767-2.834a.928.928 0 0 1 .942-.684l2.932.149L12.279.955a.928.928 0 0 1 1.165 0L15.73 2.8l2.932-.146a.928.928 0 0 1 .942.684l.767 2.834 2.458 1.605a.928.928 0 0 1 .36 1.107l-1.045 2.744 1.045 2.743a.929.929 0 0 1-.36 1.108l-2.458 1.6-.771 2.835a.927.927 0 0 1-.942.685l-2.932-.146-2.286 1.841M.75 19.769l1.656 2.609M9.908 8.147l6.294 9.916","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M15.871 17.541 2.075 21.857l-.994-1.566 9.158-11.622 5.632 8.872z","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"m5.056 20.924.876 1.346a2.041 2.041 0 0 0 2.906.614 2.256 2.256 0 0 0 .587-3.04l-.163-.236","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    